import { Pipe, PipeTransform } from '@angular/core';
import {TrimPipe} from "../trim/trim.pipe";
import {Customer} from "../../generated/sales-terminal-client";

@Pipe({
  name: 'trimCustomerName'
})
export class TrimCustomerNamePipe implements PipeTransform {
  constructor(private trimPipe: TrimPipe) {}

  transform (customer: Customer, trimAfter: number = 30) {
    const name = customer && (customer.firstName || '') + ' ' + (customer.lastName || '') || '';
    return name.length > trimAfter ? this.trimPipe.transform(name, trimAfter) + '...' : name;
  }
}
